// AUTO-GENERATED — DO NOT EDIT BY HAND.
// Regenerated by scripts/hash-sleeve-wasm.mjs as the npm `prebuild` step.
// Source: ../../public/sleeve/main.wasm
//
// At runtime, the Sleeve TS wrapper hashes the fetched WASM bytes and
// compares against SLEEVE_WASM_SHA256. Mismatch means the deployed WASM
// has been modified relative to the build's expectation — by a Cloudflare
// compromise, service-worker cache poisoning, or honest mistake — and
// the wallet refuses to instantiate it rather than running the swapped
// module silently.

export const SLEEVE_WASM_SHA256: string = '0f9edbb4cc90b2edd1cc8e4ed838b7b8d371e8cc043fc2052e8d06cd8902b07b';
export const SLEEVE_WASM_BYTES: number = 3392087;
